import React, { useEffect, useState } from 'react';
import { updateStorage, getDefaultValue } from '../../services/storageManager'
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function GroupToggle({ application, category, name, options, value, defaultValue = null, onChange, ...props }) {
    const isControlled = value !== undefined;
    const [alignment, setAlignment] = useState(() => {
        const storedValue = getDefaultValue(application, category, name);
        return storedValue !== null ? storedValue : defaultValue;
    });

    useEffect(() => {
        if (!isControlled) {
            const storedValue = getDefaultValue(application, category, name);
            setAlignment(storedValue !== null ? storedValue : defaultValue);
        }
    }, [application, category, name, defaultValue, isControlled]);

    const handleChange = (event, newAlignment) => {
        if (newAlignment !== null) { // pour éviter de réinitialiser si on clique sur l'option déjà sélectionnée
            if (!isControlled) {
                setAlignment(newAlignment);
            }
            updateStorage(application, category, name, newAlignment);
            if (onChange) {
                onChange(newAlignment, event);
            }
        }
    };

    return (
        <ToggleButtonGroup
            color="primary"
            value={isControlled ? value : alignment}
            exclusive
            onChange={handleChange}
            aria-label="Sélection d'option"
            {...props}
        >
            {options && options.map((option) => (
                <ToggleButton key={option.value} value={option.value}>
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
